/**
 * Lembra quais seções dos painéis o usuário recolheu ou abriu, entre visitas
 * (localStorage). Chave: o título da seção (único em cada painel) ou um `id`
 * explícito. Sem armazenamento (navegação privada), só não lembra.
 */
const KEY = 'amaview:secoes';

type Saved = Record<string, boolean>;

function readAll(): Saved {
  try {
    const raw = globalThis.localStorage?.getItem(KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Saved) : {};
  } catch {
    return {};
  }
}

/** Estado salvo da seção, ou null se o usuário nunca mexeu nela. */
export function readSectionOpen(key: string): boolean | null {
  const v = readAll()[key];
  return typeof v === 'boolean' ? v : null;
}

export function writeSectionOpen(key: string, open: boolean): void {
  try {
    const all = readAll();
    all[key] = open;
    globalThis.localStorage?.setItem(KEY, JSON.stringify(all));
  } catch {
    // sem armazenamento: só não lembra
  }
}
